.ldy50r0 {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: var(--_1qu8za24);
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.ldy50r1 {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}
.ldy50r2 {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: var(--_1qu8za23n);
}
.ldy50r2:hover {
  text-decoration: underline;
}